import React from 'react'
import Dashboard from '../../Screens/Owner/Dashboard'
import Products from '../../Screens/Owner/Products'
import InventoryOverview from '../../Screens/Owner/InventoryOverview'
import StockHistory from '../../Screens/Owner/StockHistory'
import StockHistoryDetail from '../../Screens/Owner/StockHistoryDetail'
import Warehouses from '../../Screens/Owner/Warehouses'
import Branches from '../../Screens/Owner/Branches'
import TransferWarehouses from '../../Screens/Owner/TransferWarehouses'
import TransferBranches from '../../Screens/Owner/TransferBranches'
import StockTransfers from '../../Screens/Owner/StockTransfers'
import Suppliers from '../../Screens/Owner/Suppliers'
import PurchaseOrders from '../../Screens/Owner/PurchaseOrders'
import PurchaseReports from '../../Screens/Owner/PurchaseReports'
import Sales from '../../Screens/Owner/Sales'
import Orders from '../../Screens/Owner/Orders'
import Quotations from '../../Screens/Owner/Quotations'
import SystemAdmin from '../../Screens/Owner/SystemAdmin'
import Users from '../../Screens/Owner/Users'
import AuditTrail from '../../Screens/Owner/AuditTrail'
import Reports from '../../Screens/Owner/Reports'
import Profile from '../../Screens/Owner/Profile'
import BranchStock from '../../Screens/OrganisationAdmin/BranchStock'
import OwnerAddProducts from '../../Screens/Owner/OwnerAddProducts'
import OwnerImportProducts from '../../Screens/Owner/OwnerImportProducts'

const Main = ({ activeScreen, isFirstLogin, screenParams }) => {
  const renderScreen = () => {
    // If first login, only allow profile screen
    if (isFirstLogin && activeScreen !== 'profile') {
      return <Profile />
    }

    switch (activeScreen) {
      case 'dashboard':
        return <Dashboard />
      case 'products':
        return <Products />
      case 'add-products':
        return <OwnerAddProducts />
      case 'import-products':
        return <OwnerImportProducts />
      case 'inventory-overview':
        return <InventoryOverview />
      case 'stock-history':
        return <StockHistory />
      case 'stock-history-detail':
        return <StockHistoryDetail movement={screenParams?.movement} />
      case 'warehouses':
        return <Warehouses />
      case 'branches':
        return <Branches />
      case 'transfer-warehouses':
        return <TransferWarehouses />
      case 'transfer-branches':
        return <TransferBranches />
      case 'stock-transfers':
        return <StockTransfers />
      case 'suppliers':
        return <Suppliers />
      case 'purchase-orders':
        return <PurchaseOrders />
      case 'purchase-reports':
        return <PurchaseReports />
      case 'sales':
        return <Sales />
      case 'orders':
        return <Orders />
      case 'quotations':
        return <Quotations />
      case 'system-admin':
        return <SystemAdmin />
      case 'users':
        return <Users />
      case 'audit-trail':
        return <AuditTrail />
      case 'reports':
        return <Reports />
      case 'profile':
        return <Profile />
      case 'owner-branch-stock':
        return <BranchStock branch={screenParams?.branch} />
      default:
        return <Dashboard />
    }
  }

  return (
<main id="main" className="main">
      {renderScreen()}
</main>
  )
}

export default Main